// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__9iLvp","content":"GlobalSearch_content__2nkMn"};